/* Direct-to-S3 upload via a presigned URL (step 2 of the 3-step attachment flow). */

/**
 * PUTs a file to the presigned storage URL. Throws with a diagnosable message:
 * fetch() rejects without a response when the browser blocks the request
 * (CSP/CORS) or the network drops, which would otherwise surface as an
 * unhelpful "Failed to fetch".
 */
export async function putToStorage(uploadUrl, file, contentType) {
  let res;
  try {
    res = await fetch(uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': contentType },
      body: file,
    });
  } catch {
    throw new Error('Upload to storage was blocked by the browser or network. Please retry; if it persists, contact support.');
  }
  if (!res.ok) throw new Error(`Upload to storage failed (HTTP ${res.status}).`);
  return res;
}
